
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1axkx_9r09q_145",
  "item": "awsui_item_1axkx_9r09q_183",
  "disable-item-paddings": "awsui_disable-item-paddings_1axkx_9r09q_186",
  "disable-paddings": "awsui_disable-paddings_1axkx_9r09q_189",
  "sortable-item": "awsui_sortable-item_1axkx_9r09q_196"
};
  